import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-reback",
  "use": "icon-reback-usage",
  "viewBox": "0 0 1482 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1482 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-reback\"><defs><style type=\"text/css\"></style></defs><path d=\"M584.884104 272.714912V0L0 477.152657l584.884104 477.073906V674.817811c406.119203 0 690.568023 108.991464 893.588249 347.528417-81.271091-340.755826-324.926863-681.354149-893.588249-749.631316\" fill=\"#467CFD\" p-id=\"1912\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol